import { createFileRoute } from '@tanstack/react-router'

import { RequireOperator } from '@/identity/RequireOperator'

/**
 * The console, and the gate in front of all of it.
 *
 * A layout route rather than a decision each page makes for itself: every
 * address beneath this one requires an operator, which is the whole reason they
 * are beneath it, and a page added tomorrow inherits that by being in this
 * directory.
 */
export const Route = createFileRoute('/admin')({ component: RequireOperator })
